import { useMemo } from 'react';
import { ace_hooks } from '@axo/shared/data-access/hooks';
import { Classes } from '@blueprintjs/core';

export function BucketStats({ id }: { id: string }) {
  const stats = ace_hooks.useBucketSummaries();

  const stat = useMemo(
    () => stats.data?.Items?.find((summary) => summary.BucketID === id),
    [stats.data?.Items, id],
  );

  if (stats.isLoading) {
    return <span className={Classes.SKELETON}>%/%</span>;
  }

  if (stat === undefined) {
    return <span className={Classes.TEXT_MUTED}>-</span>;
  }

  return (
    <>
      {stat.NumApplicationsAssigned}/{stat.NumApplicationsUnassigned}
    </>
  );
}
